export enum KNOWLEDGEBASE_DEFAULT_FIELDS {}
